import React from "react";
import { User } from "~/common/Store/models/User";
import {
  SelectedProduct,
  PromotedProductBrandAd,
} from "~/common/Store/models/ProductListing";
import ProductAd from "./ProductAd";

interface Props {
  productListingView: "list" | "grid";
  brandAd: PromotedProductBrandAd;
  user: User;
  mounted: boolean;
  fillPartialRowForGridView?: boolean;
}

const PromotedProductAd = ({
  user,
  brandAd,
  productListingView,
  mounted,
  fillPartialRowForGridView = false,
}: Props) => {
  const { product } = brandAd;

  // Promoted Product Ads only display sale price, p1, and lowest qty discount
  const selectedProduct: SelectedProduct = {
    ...product,
    activeSale: product.price.displaySalePrice,
    isOutlet: product.outletAttributes && product.outletAttributes.isOutlet,
    price: {
      ...product.price,
      minimumAdvertisedPriceProperties: {
        // Override MAP
        price: 0,
        type: "",
      },
    },
  };

  if (!product.isInStock) {
    return <></>;
  }

  return (
    <>
      {fillPartialRowForGridView && productListingView === "grid" && (
        <div
          style={{
            width: "500%",
            display: "flex",
            flexDirection: "column",
            background: "#fff",
          }}
          data-testid="ad-partial-fill"
        />
      )}
      <ProductAd
        brandAd={brandAd}
        user={user}
        mounted={mounted}
        selectedProduct={selectedProduct}
      />
    </>
  );
};

export default PromotedProductAd;
